const autoNgTemplateLoaderTemplate1 = require('./createConfiguration.html');

angular.module('portainer.kubernetes').component('kubernetesCreateConfigurationView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesCreateConfigurationController',
  controllerAs: 'ctrl',
});
